(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[12],{

/***/ "+QRC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__("E9nw");

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ "7ljp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDXContext", function() { return MDXContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDXProvider", function() { return MDXProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mdx", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useMDXComponents", function() { return useMDXComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withMDXComponents", function() { return withMDXComponents; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);


function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};

var MDXContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});
var withMDXComponents = function withMDXComponents(Component) {
  return function (props) {
    var allComponents = useMDXComponents(props.components);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({}, props, {
      components: allComponents
    }));
  };
};
var useMDXComponents = function useMDXComponents(components) {
  var contextComponents = react__WEBPACK_IMPORTED_MODULE_0___default.a.useContext(MDXContext);
  var allComponents = contextComponents;

  if (components) {
    allComponents = isFunction(components) ? components(contextComponents) : _objectSpread2(_objectSpread2({}, contextComponents), components);
  }

  return allComponents;
};
var MDXProvider = function MDXProvider(props) {
  var allComponents = useMDXComponents(props.components);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(MDXContext.Provider, {
    value: allComponents
  }, props.children);
};

var TYPE_PROP_NAME = 'mdxType';
var DEFAULTS = {
  inlineCode: 'code',
  wrapper: function wrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, {}, children);
  }
};
var MDXCreateElement = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.forwardRef(function (props, ref) {
  var propComponents = props.components,
      mdxType = props.mdxType,
      originalType = props.originalType,
      parentName = props.parentName,
      etc = _objectWithoutProperties(props, ["components", "mdxType", "originalType", "parentName"]);

  var components = useMDXComponents(propComponents);
  var type = mdxType;
  var Component = components["".concat(parentName, ".").concat(type)] || components[type] || DEFAULTS[type] || originalType;

  if (propComponents) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _objectSpread2(_objectSpread2({
      ref: ref
    }, etc), {}, {
      components: propComponents
    }));
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _objectSpread2({
    ref: ref
  }, etc));
});
MDXCreateElement.displayName = 'MDXCreateElement';
function createElement (type, props) {
  var args = arguments;
  var mdxType = props && props.mdxType;

  if (typeof type === 'string' || mdxType) {
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = MDXCreateElement;
    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty.call(props, key)) {
        newProps[key] = props[key];
      }
    }

    newProps.originalType = type;
    newProps[TYPE_PROP_NAME] = typeof type === 'string' ? type : mdxType;
    createElementArgArray[1] = newProps;

    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    }

    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement.apply(null, createElementArgArray);
  }

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement.apply(null, args);
}




/***/ }),

/***/ "E9nw":
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ "J3Rv":
/***/ (function(module, exports, __webpack_require__) {

// *** NOTE: Do not use any ES6 features because of IE11 compatibility! ***

__webpack_require__("aoOK")
var React = __webpack_require__("q1tI")
var MDX = __webpack_require__("7ljp")

module.exports = function hydrate(params, options) {
  var compiledSource = params.compiledSource
  var renderedOutput = params.renderedOutput
  var scope = params.scope || {}
  var components = (options && options.components) || {}
  var provider = options && options.provider

  // our default result is the server-rendered output
  // we get this in front of users as quickly as possible
  var useStateResult = React.useState(
    React.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: renderedOutput,
      },
    })
  )
  var result = useStateResult[0]
  var setResult = useStateResult[1]

  // if we're server-side, we can return the raw output early
  if (typeof window === 'undefined') return result

  // if we're on the client side, we hydrate the mdx content inside
  // requestIdleCallback, since we can be fairly confident that
  // markdown - embedded components are not a high priority to get
  // to interactive compared to...anything else on the page.
  //
  // once the hydration is complete, we update the state/memo value and
  // react re-renders for us
  React.useEffect(
    function () {
      var handle = window.requestIdleCallback(function () {
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        var fullScope = Object.assign({ mdx: MDX.mdx }, components, scope)
        var keys = Object.keys(fullScope)
        var values = Object.values(fullScope)

        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        var hydrateFn = Reflect.construct(
          Function,
          ['React']
            .concat(keys)
            .concat(
              compiledSource + '\nreturn React.createElement(MDXContent, {});'
            )
        )

        var hydrated = hydrateFn.apply(hydrateFn, [React].concat(values))

        // wrapping the content with MDXProvider will allow us to customize the standard
        // markdown components (such as "h1" or "a") with the "components" object
        var wrappedWithMdxProvider = React.createElement(
          MDX.MDXProvider,
          { components: components },
          hydrated
        )

        var result = wrappedWithMdxProvider

        // finally, set the the output as the new result so that react will re-render for us
        // and cancel the idle callback since we don't need it anymore
        setResult(result)
        window.cancelIdleCallback(handle)
      })
    },
    [compiledSource]
  )

  if (provider) {
    return React.createElement(provider.component, provider.props || {}, result)
  }

  return result
}


/***/ }),

/***/ "Uw0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next-mdx-remote/hydrate.js
var hydrate = __webpack_require__("J3Rv");
var hydrate_default = /*#__PURE__*/__webpack_require__.n(hydrate);

// EXTERNAL MODULE: ./src/components/Image/index.jsx + 2 modules
var Image = __webpack_require__("W56c");

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 15 modules
var format = __webpack_require__("sWYD");

// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__("4+6U");

// EXTERNAL MODULE: ./src/components/Tutorials/Container/index.jsx + 48 modules
var Container = __webpack_require__("NCNY");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/Pill/index.jsx + 1 modules
var Pill = __webpack_require__("/uI8");

// CONCATENATED MODULE: ./src/components/FooterColumns/index.jsx
var __jsx = react_default.a.createElement;





var FooterColumns_FooterColumns = function FooterColumns(_ref) {
  var columns = _ref.columns;
  return columns.map(function (column, columnIx) {
    return __jsx("ul", {
      key: columnIx,
      className: "list w-100 w-25-ns ma0 pa0 dib flex flex-column"
    }, __jsx("li", {
      className: classnames_default()("fl v-top flex flex-column w-100 pt0-ns mt0-ns", {
        "pt3 mt2": columnIx > 0
      })
    }, __jsx("div", {
      className: "f5 fw5 pb2"
    }, column.header), column.nodes.map(function (_ref2, columnLinkIx) {
      var href = _ref2.href,
          title = _ref2.title,
          onClick = _ref2.onClick,
          callout = _ref2.callout;
      var content = null;

      if (href) {
        content = __jsx(link_default.a, {
          href: href
        }, __jsx("a", {
          title: title,
          className: "link f6 dib pointer pv2 mv1 fw5 link__decoration--hover"
        }, title));
      }

      if (onClick) {
        content = __jsx("a", {
          title: title,
          onClick: onClick,
          className: "link f6 dib pointer pv2 mv1 fw5 link__decoration--hover"
        }, title);
      }

      return __jsx("div", {
        key: columnLinkIx,
        className: "w-100 flex flex-row items-center"
      }, content, callout && __jsx(Pill["a" /* default */], {
        copy: callout,
        customClasses: {
          container: "pl2",
          copy: "f7 bg-black-05 pa1 br2 fw5 flex-shrink-0 ph2 fw6"
        }
      }));
    })));
  });
};

/* harmony default export */ var components_FooterColumns = (FooterColumns_FooterColumns);
// EXTERNAL MODULE: ./src/utils/paths.js
var paths = __webpack_require__("5mj7");

// CONCATENATED MODULE: ./src/components/Tutorials/Footer/index.jsx
var Footer_jsx = react_default.a.createElement;



var COLUMNS = [{
  header: "Resources",
  nodes: [{
    href: paths["d" /* default */].TUTORIALS,
    title: "Tutorials"
  }, {
    href: paths["d" /* default */].DOCS,
    title: "Documentation"
  }]
}];

var Footer_Footer = function Footer() {
  return Footer_jsx("footer", {
    className: "pa3 ph0-l pv4-m pv4-l flex flex-column items-start"
  }, Footer_jsx("ul", {
    className: "list ma0 pa0 flex flex-column flex-row-l w-100 pb3 pb4-l"
  }, Footer_jsx(components_FooterColumns, {
    columns: COLUMNS
  })));
};

/* harmony default export */ var Tutorials_Footer = (Footer_Footer);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// CONCATENATED MODULE: ./src/components/Separator/index.jsx

var Separator_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var DEFAULT_CLASSES = {
  container: "w-100 ph3 pv3 dib",
  body: "hairline-1 bb w-100"
};

var Separator = function Separator(_ref) {
  var customClasses = _ref.customClasses;

  var _DEFAULT_CLASSES$cust = _objectSpread(_objectSpread({}, DEFAULT_CLASSES), customClasses),
      container = _DEFAULT_CLASSES$cust.container,
      body = _DEFAULT_CLASSES$cust.body;

  return Separator_jsx("div", {
    className: container
  }, Separator_jsx("div", {
    className: body
  }));
};

/* harmony default export */ var components_Separator = (Separator);
// CONCATENATED MODULE: ./src/utils/metadata.js
var getStaticContainerMeta = function getStaticContainerMeta(_ref) {
  var navConfig = _ref.navConfig,
      frontMatter = _ref.frontMatter;
  return {
    navConfig: navConfig,
    title: "".concat(frontMatter.title, " \u2013 PriceBlocs"),
    description: frontMatter.summary,
    image: "https://priceblocs.com".concat(frontMatter.image),
    date: new Date(frontMatter.publishedAt).toISOString(),
    type: "article"
  };
};
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// CONCATENATED MODULE: ./src/components/Tutorials/Layout/index.jsx

var Layout_jsx = react_default.a.createElement;








var Layout_TutorialLayout = function TutorialLayout(_ref) {
  var children = _ref.children,
      frontMatter = _ref.frontMatter,
      navConfig = _ref.navConfig;

  var _useRouter = Object(next_router["useRouter"])(),
      asPath = _useRouter.asPath;

  return Layout_jsx(Container["a" /* default */], getStaticContainerMeta({
    frontMatter: frontMatter,
    navConfig: navConfig
  }), Layout_jsx("article", {
    /**
     * Use as path as key so that the component is remounted between renders
     * This allows the new page to scroll to the top
     */
    key: asPath,
    className: "layout__article flex flex-column w-100 overflow-y-scroll-l"
  }, Layout_jsx("div", {
    className: "items-start mw7 center"
  }, Layout_jsx("h1", {
    className: "fw6 f2 f1-ns tracked-tight mb2"
  }, frontMatter.title), Layout_jsx("div", {
    className: "flex flex-column flex-row-ns justify-between items-start items-center-ns w-100 mt2 mb3"
  }, Layout_jsx("div", {
    className: "flex items-center"
  }, Layout_jsx(Image["a" /* default */], {
    alt: "Shane Rogers",
    height: 24,
    width: 24,
    src: "/tutorials/static/images/authors/shane_rogers.jpeg",
    className: "br-100"
  }), Layout_jsx("p", {
    className: "f6 black-70 ml2"
  }, frontMatter.by, "Shane Rogers / ", Object(format["a" /* default */])(Object(parseISO["a" /* default */])(frontMatter.publishedAt), "MMMM dd, yyyy"))), Layout_jsx("p", {
    className: "f6"
  }, frontMatter.readingTime.text)), Layout_jsx("div", {
    className: "w-100"
  }, children), Layout_jsx(components_Separator, {
    customClasses: {
      container: "w-100 pb3 pt5"
    }
  }), Layout_jsx(Tutorials_Footer, null))));
};

/* harmony default export */ var Layout = (Layout_TutorialLayout);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// CONCATENATED MODULE: ./src/components/MDX/Link/index.jsx


var Link_jsx = react_default.a.createElement;



var Link_Link = function Link(props) {
  var href = props.href;
  var isInternalLink = href && (href.startsWith("/") || href.startsWith("#"));

  if (isInternalLink) {
    var linkHref = props.href,
        rest = Object(objectWithoutProperties["a" /* default */])(props, ["href"]);

    return Link_jsx(link_default.a, {
      href: linkHref
    }, Link_jsx("a", rest));
  }

  return Link_jsx("a", Object(esm_extends["a" /* default */])({
    target: "_blank",
    className: "fw5 link",
    rel: "noopener noreferrer"
  }, props));
};

/* harmony default export */ var MDX_Link = (Link_Link);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);

// EXTERNAL MODULE: ./node_modules/prism-react-renderer/prism/index.js
var prism = __webpack_require__("SVOR");

// CONCATENATED MODULE: ./node_modules/prism-react-renderer/themes/duotoneDark/index.js
// Duotone Dark
// Author: Simurai, adapted from DuoTone themes for Atom (http://simurai.com/projects/2016/01/01/duotone-themes)
// Conversion: Bram de Haan (http://atelierbram.github.io/Base2Tone-prism/output/prism/prism-base2tone-evening-dark.css)
// Generated with Base16 Builder (https://github.com/base16-builder/base16-builder)
var theme = {
  plain: {
    backgroundColor: "#2a2734",
    color: "#9a86fd"
  },
  styles: [{
    types: ["comment", "prolog", "doctype", "cdata", "punctuation"],
    style: {
      color: "#6c6783"
    }
  }, {
    types: ["namespace"],
    style: {
      opacity: 0.7
    }
  }, {
    types: ["tag", "operator", "number"],
    style: {
      color: "#e09142"
    }
  }, {
    types: ["property", "function"],
    style: {
      color: "#9a86fd"
    }
  }, {
    types: ["tag-id", "selector", "atrule-id"],
    style: {
      color: "#eeebff"
    }
  }, {
    types: ["attr-name"],
    style: {
      color: "#c4b9fe"
    }
  }, {
    types: ["boolean", "string", "entity", "url", "attr-value", "keyword", "control", "directive", "unit", "statement", "regex", "at-rule", "placeholder", "variable"],
    style: {
      color: "#ffcc99"
    }
  }, {
    types: ["deleted"],
    style: {
      textDecorationLine: "line-through"
    }
  }, {
    types: ["inserted"],
    style: {
      textDecorationLine: "underline"
    }
  }, {
    types: ["italic"],
    style: {
      fontStyle: "italic"
    }
  }, {
    types: ["important", "bold"],
    style: {
      fontWeight: "bold"
    }
  }, {
    types: ["important"],
    style: {
      color: "#c4b9fe"
    }
  }]
};

/* harmony default export */ var duotoneDark = (theme);

// CONCATENATED MODULE: ./node_modules/prism-react-renderer/dist/index.js





var defaultProps = {
  // $FlowFixMe
  Prism: prism["a" /* default */],
  theme: duotoneDark
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var newlineRe = /\r\n|\r|\n/; // Empty lines need to contain a single empty token, denoted with { empty: true }

var normalizeEmptyLines = function (line) {
  if (line.length === 0) {
    line.push({
      types: ["plain"],
      content: "",
      empty: true
    });
  } else if (line.length === 1 && line[0].content === "") {
    line[0].empty = true;
  }
};

var appendTypes = function (types, add) {
  var typesSize = types.length;

  if (typesSize > 0 && types[typesSize - 1] === add) {
    return types;
  }

  return types.concat(add);
}; // Takes an array of Prism's tokens and groups them by line, turning plain
// strings into tokens as well. Tokens can become recursive in some cases,
// which means that their types are concatenated. Plain-string tokens however
// are always of type "plain".
// This is not recursive to avoid exceeding the call-stack limit, since it's unclear
// how nested Prism's tokens can become


var normalizeTokens = function (tokens) {
  var typeArrStack = [[]];
  var tokenArrStack = [tokens];
  var tokenArrIndexStack = [0];
  var tokenArrSizeStack = [tokens.length];
  var i = 0;
  var stackIndex = 0;
  var currentLine = [];
  var acc = [currentLine];

  while (stackIndex > -1) {
    while ((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]) {
      var content = void 0;
      var types = typeArrStack[stackIndex];
      var tokenArr = tokenArrStack[stackIndex];
      var token = tokenArr[i]; // Determine content and append type to types if necessary

      if (typeof token === "string") {
        types = stackIndex > 0 ? types : ["plain"];
        content = token;
      } else {
        types = appendTypes(types, token.type);

        if (token.alias) {
          types = appendTypes(types, token.alias);
        }

        content = token.content;
      } // If token.content is an array, increase the stack depth and repeat this while-loop


      if (typeof content !== "string") {
        stackIndex++;
        typeArrStack.push(types);
        tokenArrStack.push(content);
        tokenArrIndexStack.push(0);
        tokenArrSizeStack.push(content.length);
        continue;
      } // Split by newlines


      var splitByNewlines = content.split(newlineRe);
      var newlineCount = splitByNewlines.length;
      currentLine.push({
        types: types,
        content: splitByNewlines[0]
      }); // Create a new line for each string on a new line

      for (var i$1 = 1; i$1 < newlineCount; i$1++) {
        normalizeEmptyLines(currentLine);
        acc.push(currentLine = []);
        currentLine.push({
          types: types,
          content: splitByNewlines[i$1]
        });
      }
    } // Decreate the stack depth


    stackIndex--;
    typeArrStack.pop();
    tokenArrStack.pop();
    tokenArrIndexStack.pop();
    tokenArrSizeStack.pop();
  }

  normalizeEmptyLines(currentLine);
  return acc;
};

var themeToDict = function (theme, language) {
  var plain = theme.plain; // $FlowFixMe

  var base = Object.create(null);
  var themeDict = theme.styles.reduce(function (acc, themeEntry) {
    var languages = themeEntry.languages;
    var style = themeEntry.style;

    if (languages && !languages.includes(language)) {
      return acc;
    }

    themeEntry.types.forEach(function (type) {
      // $FlowFixMe
      var accStyle = _extends({}, acc[type], style);

      acc[type] = accStyle;
    });
    return acc;
  }, base); // $FlowFixMe

  themeDict.root = plain; // $FlowFixMe

  themeDict.plain = _extends({}, plain, {
    backgroundColor: null
  });
  return themeDict;
};

function dist_objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];

  return target;
}

var Highlight =
/*@__PURE__*/
function (Component) {
  function Highlight() {
    var this$1 = this;
    var args = [],
        len = arguments.length;

    while (len--) args[len] = arguments[len];

    Component.apply(this, args);

    _defineProperty(this, "getThemeDict", function (props) {
      if (this$1.themeDict !== undefined && props.theme === this$1.prevTheme && props.language === this$1.prevLanguage) {
        return this$1.themeDict;
      }

      this$1.prevTheme = props.theme;
      this$1.prevLanguage = props.language;
      var themeDict = props.theme ? themeToDict(props.theme, props.language) : undefined;
      return this$1.themeDict = themeDict;
    });

    _defineProperty(this, "getLineProps", function (ref) {
      var key = ref.key;
      var className = ref.className;
      var style = ref.style;
      var rest$1 = dist_objectWithoutProperties(ref, ["key", "className", "style", "line"]);
      var rest = rest$1;

      var output = _extends({}, rest, {
        className: "token-line",
        style: undefined,
        key: undefined
      });

      var themeDict = this$1.getThemeDict(this$1.props);

      if (themeDict !== undefined) {
        output.style = themeDict.plain;
      }

      if (style !== undefined) {
        output.style = output.style !== undefined ? _extends({}, output.style, style) : style;
      }

      if (key !== undefined) {
        output.key = key;
      }

      if (className) {
        output.className += " " + className;
      }

      return output;
    });

    _defineProperty(this, "getStyleForToken", function (ref) {
      var types = ref.types;
      var empty = ref.empty;
      var typesSize = types.length;
      var themeDict = this$1.getThemeDict(this$1.props);

      if (themeDict === undefined) {
        return undefined;
      } else if (typesSize === 1 && types[0] === "plain") {
        return empty ? {
          display: "inline-block"
        } : undefined;
      } else if (typesSize === 1 && !empty) {
        return themeDict[types[0]];
      }

      var baseStyle = empty ? {
        display: "inline-block"
      } : {}; // $FlowFixMe

      var typeStyles = types.map(function (type) {
        return themeDict[type];
      });
      return Object.assign.apply(Object, [baseStyle].concat(typeStyles));
    });

    _defineProperty(this, "getTokenProps", function (ref) {
      var key = ref.key;
      var className = ref.className;
      var style = ref.style;
      var token = ref.token;
      var rest$1 = dist_objectWithoutProperties(ref, ["key", "className", "style", "token"]);
      var rest = rest$1;

      var output = _extends({}, rest, {
        className: "token " + token.types.join(" "),
        children: token.content,
        style: this$1.getStyleForToken(token),
        key: undefined
      });

      if (style !== undefined) {
        output.style = output.style !== undefined ? _extends({}, output.style, style) : style;
      }

      if (key !== undefined) {
        output.key = key;
      }

      if (className) {
        output.className += " " + className;
      }

      return output;
    });
  }

  if (Component) Highlight.__proto__ = Component;
  Highlight.prototype = Object.create(Component && Component.prototype);
  Highlight.prototype.constructor = Highlight;

  Highlight.prototype.render = function render() {
    var ref = this.props;
    var Prism = ref.Prism;
    var language = ref.language;
    var code = ref.code;
    var children = ref.children;
    var themeDict = this.getThemeDict(this.props);
    var grammar = Prism.languages[language];
    var mixedTokens = grammar !== undefined ? Prism.tokenize(code, grammar, language) : [code];
    var tokens = normalizeTokens(mixedTokens);
    return children({
      tokens: tokens,
      className: "prism-code language-" + language,
      style: themeDict !== undefined ? themeDict.root : {},
      getLineProps: this.getLineProps,
      getTokenProps: this.getTokenProps
    });
  };

  return Highlight;
}(react["Component"]);

/* harmony default export */ var dist = (Highlight);


// CONCATENATED MODULE: ./node_modules/prism-react-renderer/themes/nightOwl/index.js
// Original: https://github.com/sdras/night-owl-vscode-theme
// Converted automatically using ./tools/themeFromVsCode
var nightOwl_theme = {
  plain: {
    color: "#d6deeb",
    backgroundColor: "#011627"
  },
  styles: [{
    types: ["changed"],
    style: {
      color: "rgb(162, 191, 252)",
      fontStyle: "italic"
    }
  }, {
    types: ["deleted"],
    style: {
      color: "rgba(239, 83, 80, 0.56)",
      fontStyle: "italic"
    }
  }, {
    types: ["inserted", "attr-name"],
    style: {
      color: "rgb(173, 219, 103)",
      fontStyle: "italic"
    }
  }, {
    types: ["comment"],
    style: {
      color: "rgb(99, 119, 119)",
      fontStyle: "italic"
    }
  }, {
    types: ["string", "url"],
    style: {
      color: "rgb(173, 219, 103)"
    }
  }, {
    types: ["variable"],
    style: {
      color: "rgb(214, 222, 235)"
    }
  }, {
    types: ["number"],
    style: {
      color: "rgb(247, 140, 108)"
    }
  }, {
    types: ["builtin", "char", "constant", "function"],
    style: {
      color: "rgb(130, 170, 255)"
    }
  }, {
    // This was manually added after the auto-generation
    // so that punctuations are not italicised
    types: ["punctuation"],
    style: {
      color: "rgb(199, 146, 234)"
    }
  }, {
    types: ["selector", "doctype"],
    style: {
      color: "rgb(199, 146, 234)",
      fontStyle: "italic"
    }
  }, {
    types: ["class-name"],
    style: {
      color: "rgb(255, 203, 139)"
    }
  }, {
    types: ["tag", "operator", "keyword"],
    style: {
      color: "rgb(127, 219, 202)"
    }
  }, {
    types: ["boolean"],
    style: {
      color: "rgb(255, 88, 116)"
    }
  }, {
    types: ["property"],
    style: {
      color: "rgb(128, 203, 196)"
    }
  }, {
    types: ["namespace"],
    style: {
      color: "rgb(178, 204, 214)"
    }
  }]
};

/* harmony default export */ var nightOwl = (nightOwl_theme);

// EXTERNAL MODULE: ./src/utils/constants/ui.js
var ui = __webpack_require__("IWZK");

// CONCATENATED MODULE: ./src/components/MDX/Snippet/styles.js

var styles = [".code--wrapper.jsx-1045612559{font-size:1.125rem;line-height:1.625;}", "pre.code__pre.jsx-1045612559{border-width:1px;overflow-x:auto;white-space:normal;word-break:break-all;font-size:0.875em;line-height:1.7142857;margin-top:1.7142857em;margin-bottom:1.7142857em;border-radius:0.375rem;padding:0.8571429em 1.1428571em;--tw-border-opacity:1;border-width:1px;border-color:whitesmoke;}", "@media (max-width:".concat(ui["j" /* PHONE */], "px){pre.code__pre.jsx-1045612559{width:calc(100vw - 2rem);}}"), ".code__pre.jsx-1045612559 .token-line.jsx-1045612559{line-height:1.3rem;height:1.3rem;}", ".code__line.jsx-1045612559{display:table-row;}", ".code__line--no.jsx-1045612559{display:table-cell;text-align:right;padding-right:1rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;opacity:0.5;}", ".code__line--content.jsx-1045612559{display:table-cell;}"];
styles.__hash = "1045612559";
// EXTERNAL MODULE: ./node_modules/react-toast-notifications/dist/index.js
var react_toast_notifications_dist = __webpack_require__("tbn6");

// EXTERNAL MODULE: ./node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__("+QRC");
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);

// EXTERNAL MODULE: ./src/components/HoverIconButton/index.jsx + 7 modules
var HoverIconButton = __webpack_require__("gDcV");

// EXTERNAL MODULE: ./src/utils/analytics.js + 15 modules
var analytics = __webpack_require__("svBA");

// CONCATENATED MODULE: ./src/components/CopyToClipboard/index.jsx
var CopyToClipboard_jsx = react_default.a.createElement;





var DEFAULT_TOAST = "Copied Price to clipboard";

var CopyToClipboard_CopyToClipboard = function CopyToClipboard(_ref) {
  var value = _ref.value,
      tooltip = _ref.tooltip,
      toast = _ref.toast,
      tracking = _ref.tracking,
      _onClick = _ref.onClick,
      customClasses = _ref.customClasses;

  var _useToasts = Object(react_toast_notifications_dist["useToasts"])(),
      addToast = _useToasts.addToast;

  var _useState = Object(react["useState"])(""),
      _ = _useState[0],
      setClipboard = _useState[1];

  var ctxToast = toast || DEFAULT_TOAST;
  return CopyToClipboard_jsx(HoverIconButton["a" /* default */], {
    type: "copy",
    customClasses: customClasses,
    tooltip: tooltip || "Copy Price ID",
    onClick: function onClick() {
      _onClick && _onClick();
      tracking && analytics["g" /* default */].trackEventWithData(tracking);
      setClipboard(value);
      copy_to_clipboard_default()(value);
      addToast(ctxToast, {
        appearance: "info",
        autoDismiss: true
      });
    }
  });
};

/* harmony default export */ var components_CopyToClipboard = (CopyToClipboard_CopyToClipboard);
// CONCATENATED MODULE: ./src/components/MDX/Snippet/index.jsx


var Snippet_jsx = react_default.a.createElement;







var Snippet_Snippet = function Snippet(_ref) {
  var code = _ref.code,
      withLines = _ref.withLines,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? "jsx" : _ref$language;
  return Snippet_jsx(react_toast_notifications_dist["ToastProvider"], {
    placement: "bottom-left"
  }, Snippet_jsx("div", {
    className: "w-100 relative"
  }, Snippet_jsx(dist, Object(esm_extends["a" /* default */])({}, defaultProps, {
    theme: nightOwl,
    code: code,
    language: language
  }), function (_ref2) {
    var className = _ref2.className,
        style = _ref2.style,
        tokens = _ref2.tokens,
        getLineProps = _ref2.getLineProps,
        getTokenProps = _ref2.getTokenProps;
    return Snippet_jsx("pre", {
      style: style,
      className: "jsx-".concat(styles.__hash) + " " + "code__pre ".concat(className)
    }, tokens.map(function (line, i) {
      return withLines ? Snippet_jsx("div", Object(esm_extends["a" /* default */])({
        key: i
      }, getLineProps({
        line: line,
        key: i
      }), {
        className: "jsx-".concat(styles.__hash) + " " + "code__line"
      }), Snippet_jsx("div", {
        className: "jsx-".concat(styles.__hash) + " " + "code__line--no"
      }, i + 1), Snippet_jsx("div", {
        className: "jsx-".concat(styles.__hash) + " " + "code__line--content"
      }, line.map(function (token, key) {
        return Snippet_jsx("span", Object(esm_extends["a" /* default */])({
          key: key
        }, getTokenProps({
          token: token,
          key: key
        }), {
          className: "jsx-".concat(styles.__hash)
        }));
      }))) : Snippet_jsx("div", Object(esm_extends["a" /* default */])({}, getLineProps({
        line: line,
        key: i
      }), {
        className: "jsx-".concat(styles.__hash)
      }), line.map(function (token, key) {
        return Snippet_jsx("span", Object(esm_extends["a" /* default */])({}, getTokenProps({
          token: token,
          key: key
        }), {
          className: "jsx-".concat(styles.__hash)
        }));
      }));
    }), Snippet_jsx(style_default.a, {
      id: styles.__hash
    }, styles));
  }), Snippet_jsx("div", {
    className: "absolute top-0 right-0"
  }, Snippet_jsx(components_CopyToClipboard, {
    tooltip: "Copy snippet",
    toast: "Copied snippet",
    value: code
  }))));
};

/* harmony default export */ var MDX_Snippet = (Snippet_Snippet);
// EXTERNAL MODULE: ./src/components/Form/fields/Button.js + 1 modules
var Button = __webpack_require__("TEwj");

// CONCATENATED MODULE: ./src/components/SlimCTA/index.jsx


var SlimCTA_jsx = react_default.a.createElement;

function SlimCTA_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SlimCTA_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SlimCTA_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SlimCTA_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SlimCTA_DEFAULT_CLASSES = {
  container: "w-100 flex flex-column flex-row-ns justify-between ba br2 hairline-1 pa3 items-start items-center-ns bg-white",
  content: "flex flex-column",
  header: "f4 fw6",
  subheader: "f5 lh-copy",
  actionsWrapper: "pt2 pl2-ns pt0-ns",
  actionsRow: "flex flex-row"
};

var SlimCTA_SlimCTA = function SlimCTA(_ref) {
  var header = _ref.header,
      subheader = _ref.subheader,
      actions = _ref.actions,
      customClasses = _ref.customClasses;

  var classes = SlimCTA_objectSpread(SlimCTA_objectSpread({}, SlimCTA_DEFAULT_CLASSES), customClasses);

  var actionNodes = actions && actions.length > 0 && SlimCTA_jsx("div", {
    className: classes.actionsWrapper
  }, SlimCTA_jsx("div", {
    className: classes.actionsRow
  }, actions.map(function (action, actionIx) {
    return SlimCTA_jsx(Button["a" /* default */], Object(esm_extends["a" /* default */])({
      key: actionIx,
      theme: ui["q" /* UI_THEME */].SLIM
    }, action));
  })));

  return SlimCTA_jsx("div", {
    className: classes.container
  }, SlimCTA_jsx("div", {
    className: classes.content
  }, header && SlimCTA_jsx("div", {
    className: classes.header
  }, header), subheader && SlimCTA_jsx("div", {
    className: classnames_default()(classes.subheader, {
      pt2: header
    })
  }, subheader)), actionNodes);
};

/* harmony default export */ var components_SlimCTA = (SlimCTA_SlimCTA);
// CONCATENATED MODULE: ./src/utils/crisp.js
// https://help.crisp.chat/en/article/how-to-use-dollarcrisp-javascript-sdk-10ud15y/
var WHAT_INTEGRATION = "What integration would you like?";
var HELP_DISABLED_ACCOUNT = "Has your account been incorrectly disabled? Let us know why.";
var HELP_SUSPENDED_SUBSCRIPTION = "Has your subscription been suspended incorrectly? Let us know why.";
var INTEGRATION_REQUEST_FIELD = {
  id: "integration-request",
  text: "What integration would you like?",
  explain: "Enter an integration name..."
};
var DEFAULT_HELP_MESSAGE = "What can we help with?";
var crispComposerWithMessage = function crispComposerWithMessage() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_HELP_MESSAGE;

  if ( true && window.$crisp) {
    window.$crisp.push(["do", "message:show", ["text", message]]);
  }
};
var crispField = function crispField(field) {
  if ( true && window.$crisp) {
    window.$crisp.push(["do", "message:show", ["field", field]]);
  }
};
var crispHide = function crispHide() {
  if ( true && window.$crisp) {
    window.$crisp.push(["do", "chat:hide"]);
  }
};
var crispShow = function crispShow() {
  if ( true && window.$crisp) {
    window.$crisp.push(["do", "chat:show"]);
  }
};
// CONCATENATED MODULE: ./src/components/MDX/Chat/index.jsx
var Chat_jsx = react_default.a.createElement;





var Chat_Chat = function Chat(_ref) {
  var message = _ref.message;
  return Chat_jsx("div", {
    className: "pt3"
  }, Chat_jsx(components_SlimCTA, {
    header: "Have any questions or feedback?",
    subheader: "Let us know in the chat.",
    actions: [{
      tag: ui["b" /* BUTTON_TAGS */].BUTTON,
      onClick: function onClick() {
        return crispComposerWithMessage(message);
      },
      copy: "Start chat"
    }]
  }));
};

/* harmony default export */ var MDX_Chat = (Chat_Chat);
// CONCATENATED MODULE: ./src/components/MDX/Table/index.jsx
var Table_jsx = react_default.a.createElement;



var Table_Table = function Table(_ref) {
  var columns = _ref.columns,
      rows = _ref.rows;
  return Table_jsx("table", {
    className: "f6 w-100 mw8 center ba b--black-10 br2",
    cellSpacing: "0"
  }, Table_jsx("thead", null, Table_jsx("tr", null, columns.map(function (column, columnIx) {
    return Table_jsx("th", {
      key: columnIx,
      className: "fw6 bb b--black-10 tl pa3"
    }, column);
  }))), Table_jsx("tbody", {
    className: "lh-copy"
  }, rows.map(function (row, rowIx) {
    return Table_jsx("tr", {
      key: rowIx
    }, row.map(function (cell, cellIx) {
      return Table_jsx("td", {
        key: cellIx,
        className: classnames_default()("pa3", {
          "bb b--black-10": rowIx !== rows.length - 1
        })
      }, cell);
    }));
  })));
};

/* harmony default export */ var MDX_Table = (Table_Table);
// CONCATENATED MODULE: ./src/components/MDX/Blockquote/index.jsx
var Blockquote_jsx = react_default.a.createElement;


var Blockquote = function Blockquote(_ref) {
  var children = _ref.children;
  return Blockquote_jsx("div", {
    className: "ph3 f6 ba br2 hairline-1 bg-content--secondary mv3"
  }, children);
};

/* harmony default export */ var MDX_Blockquote = (Blockquote);
// EXTERNAL MODULE: ./src/utils/styles.js
var utils_styles = __webpack_require__("oCA+");

// CONCATENATED MODULE: ./src/components/MDX/UnorderedList/index.jsx

var UnorderedList_jsx = react_default.a.createElement;



var UnorderedList_UnorderedList = function UnorderedList(_ref) {
  var children = _ref.children;
  return UnorderedList_jsx("ul", {
    className: style_default.a.dynamic([["188850253", [utils_styles["a" /* COLORS */].blue]]]) + " " + "custom__list list ma0 pa0 relative"
  }, children, UnorderedList_jsx(style_default.a, {
    id: "188850253",
    dynamic: [utils_styles["a" /* COLORS */].blue]
  }, ["ul.custom__list > li{margin-top:.5em;margin-bottom:.5em;position:relative;padding-left:1.75rem;list-style-position:inside;padding-top:3px;line-height:1.5;}", "ul.custom__list > li > a{color:".concat(utils_styles["a" /* COLORS */].blue, ";font-weight:500;-webkit-text-decoration:none;text-decoration:none;}"), "ul.custom__list > li > a:hover{-webkit-text-decoration:underline !important;text-decoration:underline !important;-webkit-text-decoration-line:underline !important;text-decoration-line:underline !important;-webkit-text-decoration-style:initial !important;text-decoration-style:initial !important;-webkit-text-decoration-color:initial !important;text-decoration-color:initial !important;}", "ul.custom__list > li:before{content:\"\";position:absolute;background-color:#d1d5db;border-radius:50%;width:.375em;height:.375em;top:calc(.875em - .1875em);left:.25em;}"]));
};

/* harmony default export */ var MDX_UnorderedList = (UnorderedList_UnorderedList);
// CONCATENATED MODULE: ./src/components/MDX/OrderedList/index.jsx

var OrderedList_jsx = react_default.a.createElement;



var OrderedList_OrderedList = function OrderedList(_ref) {
  var children = _ref.children;
  return OrderedList_jsx("ol", {
    className: style_default.a.dynamic([["23917918", [utils_styles["a" /* COLORS */].blue]]]) + " " + "custom__list list ma0 pa0 relative"
  }, children, OrderedList_jsx(style_default.a, {
    id: "23917918",
    dynamic: [utils_styles["a" /* COLORS */].blue]
  }, ["ol.custom__list > li{position:relative;counter-increment:list-counter;margin-top:.5em;margin-bottom:.5em;position:relative;padding-left:1.75rem;list-style-position:inside;padding-top:3px;line-height:1.5;}", "ol.custom__list > li > a{color:".concat(utils_styles["a" /* COLORS */].blue, ";font-weight:500;-webkit-text-decoration:none;text-decoration:none;}"), "ol.custom__list > li > a:hover{-webkit-text-decoration:underline !important;text-decoration:underline !important;-webkit-text-decoration-line:underline !important;text-decoration-line:underline !important;-webkit-text-decoration-style:initial !important;text-decoration-style:initial !important;-webkit-text-decoration-color:initial !important;text-decoration-color:initial !important;}", "ol.custom__list > li:before{content:counter(list-counter) \".\";position:absolute;font-weight:400;color:#6b7280;left:0;}"]));
};

/* harmony default export */ var MDX_OrderedList = (OrderedList_OrderedList);
// CONCATENATED MODULE: ./src/components/MDX/StandardTable/index.jsx

var StandardTable_jsx = react_default.a.createElement;


var StandardTable_StandardTable = function StandardTable(_ref) {
  var children = _ref.children;
  return StandardTable_jsx("table", {
    cellSpacing: "0",
    className: "jsx-615425418" + " " + "w-100 table__wrapper tc"
  }, children, StandardTable_jsx(style_default.a, {
    id: "615425418"
  }, [".table__wrapper.jsx-615425418>td.jsx-615425418{padding:20px;}"]));
};

/* harmony default export */ var MDX_StandardTable = (StandardTable_StandardTable);
// CONCATENATED MODULE: ./src/components/MDX/Paragraph/index.jsx
var Paragraph_jsx = react_default.a.createElement;


var Paragraph = function Paragraph(_ref) {
  var children = _ref.children;
  return Paragraph_jsx("p", {
    className: "lh-copy"
  }, children);
};

/* harmony default export */ var MDX_Paragraph = (Paragraph);
// EXTERNAL MODULE: ./src/components/Padder/index.jsx
var components_Padder = __webpack_require__("gH8l");

// CONCATENATED MODULE: ./src/components/MDX/index.jsx

var MDX_jsx = react_default.a.createElement;













var MDX_Padder = function Padder() {
  return MDX_jsx(components_Padder["a" /* default */], {
    theme: "visible"
  });
};

var MDX_BlogImage = function BlogImage(props) {
  return MDX_jsx("div", {
    className: "w-100 tc"
  }, MDX_jsx(Image["a" /* default */], props));
};

var Code = function Code(props) {
  MDX_jsx("code", props);
};

var ComponentRegistry = {
  Image: MDX_BlogImage,
  a: MDX_Link,
  p: MDX_Paragraph,
  ul: MDX_UnorderedList,
  ol: MDX_OrderedList,
  table: MDX_StandardTable,
  blockquote: MDX_Blockquote,
  code: Code,
  Snippet: MDX_Snippet,
  Table: MDX_Table,
  Chat: MDX_Chat,
  SlimCTA: components_SlimCTA,
  Padder: MDX_Padder
};
/* harmony default export */ var MDX = (ComponentRegistry);
// CONCATENATED MODULE: ./src/components/Loader/Rows.jsx
var Rows_jsx = react_default.a.createElement;


var LoaderRows = function LoaderRows(_ref) {
  var rows = _ref.rows;
  return rows.map(function (el, elIx) {
    return Rows_jsx("div", {
      style: {
        width: "".concat(el, "%")
      },
      key: elIx,
      className: "flex tl fw5 f3 dib mt2"
    }, Rows_jsx("div", {
      className: "shimmer h2 w-100"
    }));
  });
};

LoaderRows.defaultProps = {
  rows: [45, 23, 60, 48, 87, 90]
};
/* harmony default export */ var Rows = (LoaderRows);
// CONCATENATED MODULE: ./src/components/DetailLoader/index.jsx

var DetailLoader_jsx = react_default.a.createElement;

function DetailLoader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DetailLoader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DetailLoader_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DetailLoader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var DetailLoader_DEFAULT_CLASSES = {
  container: "pa3 w-100"
};

var DetailLoader_DetailLoader = function DetailLoader(_ref) {
  var customClasses = _ref.customClasses;

  var classes = DetailLoader_objectSpread(DetailLoader_objectSpread({}, DetailLoader_DEFAULT_CLASSES), customClasses);

  return DetailLoader_jsx("div", {
    className: classes.container
  }, DetailLoader_jsx("div", {
    className: "flex tl fw5 f3 dib mw5"
  }, DetailLoader_jsx("div", {
    className: "shimmer h3 w5"
  })), DetailLoader_jsx(Rows, {
    rows: [75, 63, 40, 78, 47, 35]
  }), DetailLoader_jsx("div", null, DetailLoader_jsx("div", {
    className: "shimmer h3 w4 fr"
  })), DetailLoader_jsx("div", {
    className: "mt5"
  }, DetailLoader_jsx(Rows, null)));
};

/* harmony default export */ var components_DetailLoader = (DetailLoader_DetailLoader);
// CONCATENATED MODULE: ./src/components/Tutorials/Post/index.jsx

var Post_jsx = react_default.a.createElement;






var Post_Post = function Post(_ref) {
  var post = _ref.post,
      navConfig = _ref.navConfig;
  var router = Object(next_router["useRouter"])();

  if (router.isFallback) {
    return Post_jsx(components_DetailLoader, null);
  }

  var mdxSource = post.mdxSource,
      frontMatter = post.frontMatter;
  var content = hydrate_default()(mdxSource, {
    components: MDX
  });
  return Post_jsx(Layout, {
    navConfig: navConfig,
    frontMatter: frontMatter
  }, content);
};

/* harmony default export */ var Tutorials_Post = __webpack_exports__["a"] = (Post_Post);

/***/ }),

/***/ "aoOK":
/***/ (function(module, exports) {

if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now()
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        })
      }, 1)
    }

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id)
    }
}


/***/ })

}]);